module.exports = __webpack_public_path__ + "static/media/04__CALCINHA_LATERAL_DRAPEADA_ESTAMPADA_12.78c34e8a.jpg";